var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.campo.rotulo,"items":_vm.itens,"hint":_vm.campo.ajuda,"filled":"","value":_vm.value},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }